import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './routes.js';

import { store } from './store/store.js';

import Mobile from './components/mobile.vue'; 
import Welcome from './components/welcome.vue'; 
import Plains from './components/plains.vue'; 
import Ocean from './components/ocean.vue'; 
import Amazon from './components/amazon.vue'; 
import Forest from './components/forest.vue'; 
import Desert from './components/desert.vue'; 
import Beach from './components/beach.vue'; 
import NYC from './components/nyc.vue'; 
import Rural from './components/rural.vue'; 
import Ice from './components/ice.vue'; 
import Fire from './components/fire.vue'; 
import Tutorial from './components/tutorial.vue';


Vue.use(VueRouter);
Vue.component('Mobile', Mobile);
Vue.component('Welcome', Welcome);
Vue.component('Plains', Plains);
Vue.component('Ocean', Ocean);
Vue.component('Amazon', Amazon);
Vue.component('Forest', Forest);
Vue.component('Desert', Desert);
Vue.component('Beach', Beach);
Vue.component('NYC', NYC);
Vue.component('Rural', Rural);
Vue.component('Ice', Ice);
Vue.component('Fire', Fire);
Vue.component('Tutorial', Tutorial);


const router = new VueRouter({
	routes,
	mode: 'history'
});

router.beforeEach((to, from, next) => {
	document.title = to.meta.title;
	window.scrollTo(0, 0);
	next()
});

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js